import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material/styles';
import { MONTHLY_RECONCILIATION_VARIANCE_COLOR } from './constants';

const useStyles = makeStyles((theme) => ({
  clickableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme?.palette?.grey?.[700],
    },
  },
  searchFilterWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 24px',
    margin: '16px 0px 24px',
    height: '100%',
  },
  searchWrap: {
    width: '100%',
  },
  mainPaper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    border: `1px solid ${theme.palette.grey[100]}`,
  },
  headerPanel: {
    marginBottom: theme.spacing(3),
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
    position: 'relative',
  },
  headerDisclaimer: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(2),
    color: theme.palette.grey[800],
    fontSize: '11px',
    fontStyle: 'italic',
    display: 'flex',
    alignItems: 'center',
    zIndex: 1,
  },
  headerPanelContent: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  formField: {
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      width: 300,
      minWidth: 300,
      flex: 'none',
    },
  },
  productField: {
    [theme.breakpoints.up('lg')]: {
      width: 440,
      minWidth: 440,
      flex: 'none',
    },
  },
  applyButtonWrap: {
    marginLeft: 'auto',
    alignSelf: 'flex-end',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
    },
  },
  fieldLabel: {
    marginBottom: theme.spacing(0.5),
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '12px',
    textTransform: 'uppercase',
  },

  applyButton: {
    height: 40,
    padding: theme.spacing(1, 4),
    fontWeight: theme.typography.fontWeightSemiBold,
  },
  finalizeActionCard: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
  },
  finalizeActionContent: {
    padding: theme.spacing(2, 3),
    display: 'flex',
    justifyContent: 'flex-end',
  },
  finalizeButton: {
    padding: theme.spacing(1.25, 6.375),
  },

  statLabel: {
    textTransform: 'uppercase',
    fontWeight: 600,
    letterSpacing: 0.5,
    color: theme.palette.secondary.main,
  },
  statValue: {
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  statLabelContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  infoIcon: {
    fontSize: 14,
    color: theme.palette.text.secondary,
  },

  warningBox: {
    padding: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  missingDataFeedBox: {
    backgroundColor: theme.palette.warning.lighter,
  },
  unmappedDataFeedBox: {
    backgroundColor: alpha(MONTHLY_RECONCILIATION_VARIANCE_COLOR, 0.08),
  },
  unmappedDataFeedText: {
    fontWeight: 500,
    color: MONTHLY_RECONCILIATION_VARIANCE_COLOR,
  },
  warningBoxIcon: {
    color: theme.palette.warning.dark,
    fontSize: 22,
  },
  errorBoxIcon: {
    color: MONTHLY_RECONCILIATION_VARIANCE_COLOR,
    fontSize: 22,
  },
  warningBoxText: {
    fontWeight: 500,
  },

  emptyState: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.secondary,
  },
  emptyStateContainer: {
    marginTop: theme.spacing(3),
    border: `1px solid ${theme.palette.grey[100]}`,
  },
  emptyStateBox: {
    padding: theme.spacing(4),
    textAlign: 'center',
  },
  emptyStateIcon: {
    fontSize: 48,
    color: theme.palette.grey[100],
    marginBottom: theme.spacing(2),
  },
  finalizedDetailTableContainer: {
    marginTop: theme.spacing(3),
    border: `1px solid ${theme.palette.grey[100]}`,
  },
}));

export default useStyles;
